import { render, staticRenderFns } from "./VersionBar.vue?vue&type=template&id=ec75f1f4&scoped=true"
import script from "./VersionBar.vue?vue&type=script&lang=js"
export * from "./VersionBar.vue?vue&type=script&lang=js"
import style0 from "./VersionBar.vue?vue&type=style&index=0&id=ec75f1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec75f1f4",
  null
  
)

export default component.exports